import styled from "@emotion/styled";
import { Alert } from "@mui/material";

import { useCustomTranslation } from "@/utils/useCustomTranslation";

interface ErrorAlertProps {
  error: Error | null;
  className?: string;
}

export const ErrorAlert = ({ error, className }: ErrorAlertProps) => {
  const { t } = useCustomTranslation();
  return (
    <ErrorContainer className={className}>
      <Alert
        severity="error"
        sx={{ mt: 3 }}
      >
        {error instanceof Error ? error.message : t("an_error_has_occurred")}
      </Alert>
    </ErrorContainer>
  );
};

const ErrorContainer = styled.div`
  padding: 0 24px;
`;
